<template>
  <div>
    <el-dialog :title="title" :close-on-click-modal="false" :visible.sync="showDialog" width="750px"
      @close="setDialogClosed" append-to-body>
      <el-container>
        <el-tabs v-model="activeName" tab-position="left">
          <el-tab-pane label="易患筛查" name="first">
            <div style="margin-left: 20px;">
              <el-descriptions direction="vertical" :column="2" size="mini" :colon="false">
                <el-descriptions-item style="display: flex;" label="*血压（mmHg）">
                  <el-input v-model="detail.sbp" placeholder="收缩压" style="width: 100px"></el-input>/
                  <el-input v-model="detail.dbp" placeholder="舒张压" style="width: 100px"></el-input>
                </el-descriptions-item>

                <el-descriptions-item label="*身高（cm）">
                  <el-input v-model="detail.height" placeholder="请输入内容" style="width: 200px"></el-input>
                </el-descriptions-item>

                <el-descriptions-item label="*体重（kg）">
                  <el-input v-model="detail.weight" placeholder="请输入内容" style="width: 200px"></el-input>
                </el-descriptions-item>

                <el-descriptions-item label="*腰围（cm）">
                  <el-input v-model="detail.waist" placeholder="请输入内容" style="width: 200px"></el-input>
                </el-descriptions-item>


                <el-descriptions-item label="*年龄（岁）">
                  <el-input v-model="detail.age" placeholder="请输入内容" style="width: 200px"></el-input>
                </el-descriptions-item>

                <el-descriptions-item label="*糖尿病家族史">
                  <el-select v-model="detail.diabetFamily" placeholder="请选择">
                    <el-option v-for="item in familyHistoryOptions" :key="item.value" :label="item.label"
                      :value="item.value" style="width: 200px">
                    </el-option>
                  </el-select>
                </el-descriptions-item>

                <el-descriptions-item label="评估">
                  <el-button type="primary" size="small" @click="submit()" style="width: 200px">提交评估</el-button>
                </el-descriptions-item>

                <el-descriptions-item label="评分结果">
                  <el-input disabled v-model="result" style="width: 210px"></el-input>
                </el-descriptions-item>

              </el-descriptions>
            </div>

          </el-tab-pane>

          <el-tab-pane label="危险因素" name="second">
            <div style="margin-left: 20px;">
              <el-descriptions direction="vertical" :column="2" size="mini" :colon="false">
                <el-descriptions-item label="年龄≥40岁">
                  <el-select v-model="detail.commonValue" placeholder="请选择">
                    <el-option v-for="item in commonOptions" :key="item.value" :label="item.label" :value="item.value"
                      style="width: 200px">
                    </el-option>
                  </el-select>
                </el-descriptions-item>

                <el-descriptions-item label="糖尿病前期史">
                  <el-select v-model="detail.commonValue" placeholder="请选择">
                    <el-option v-for="item in commonOptions" :key="item.value" :label="item.label" :value="item.value"
                      style="width: 200px">
                    </el-option>
                  </el-select>
                </el-descriptions-item>

                <el-descriptions-item :span="2" label="BMI≥24kg/m2和(或)向心性(中心型)肥胖(男性腰围≥90cm，女性腰围≥85cm)">
                  <el-select v-model="detail.commonValue" placeholder="请选择">
                    <el-option v-for="item in commonOptions" :key="item.value" :label="item.label" :value="item.value"
                      style="width: 200px">
                    </el-option>
                  </el-select>
                </el-descriptions-item>

                <el-descriptions-item label="缺乏体力活动者">
                  <el-select v-model="detail.commonValue" placeholder="请选择">
                    <el-option v-for="item in commonOptions" :key="item.value" :label="item.label" :value="item.value"
                      style="width: 200px">
                    </el-option>
                  </el-select>
                </el-descriptions-item>

                <el-descriptions-item label="有类固醇药物使用病史">
                  <el-select v-model="detail.commonValue" placeholder="请选择">
                    <el-option v-for="item in commonOptions" :key="item.value" :label="item.label" :value="item.value"
                      style="width: 200px">
                    </el-option>
                  </el-select>
                </el-descriptions-item>

                <el-descriptions-item label="一级亲属(父母、同胞、子女)中有糖尿病家族史">
                  <el-select v-model="detail.commonValue" placeholder="请选择">
                    <el-option v-for="item in commonOptions" :key="item.value" :label="item.label" :value="item.value"
                      style="width: 200px">
                    </el-option>
                  </el-select>
                </el-descriptions-item>

                <el-descriptions-item label="女性有巨大儿分娩史或妊娠期糖尿病病史">
                  <el-select v-model="detail.commonValue" placeholder="请选择">
                    <el-option v-for="item in commonOptions" :key="item.value" :label="item.label" :value="item.value"
                      style="width: 200px">
                    </el-option>
                  </el-select>
                </el-descriptions-item>

                <el-descriptions-item label="高血压或正在接受降压治疗">
                  <el-select v-model="detail.commonValue" placeholder="请选择">
                    <el-option v-for="item in commonOptions" :key="item.value" :label="item.label" :value="item.value"
                      style="width: 200px">
                    </el-option>
                  </el-select>
                </el-descriptions-item>

                <el-descriptions-item label="动脉粥样硬化性心血管疾病(ASCVD)史">
                  <el-select v-model="detail.commonValue" placeholder="请选择">
                    <el-option v-for="item in commonOptions" :key="item.value" :label="item.label" :value="item.value"
                      style="width: 200px">
                    </el-option>
                  </el-select>
                </el-descriptions-item>

                <el-descriptions-item :span="2"
                  label="血脂异常，HDL-C≤0.91mmol/L(≤35mg/dl)和(或)TG≥2.22mmol/L(≥200mg/dl)，或正在接受调脂治疗">
                  <el-select v-model="detail.commonValue" placeholder="请选择">
                    <el-option v-for="item in commonOptions" :key="item.value" :label="item.label" :value="item.value"
                      style="width: 200px">
                    </el-option>
                  </el-select>
                </el-descriptions-item>

                <el-descriptions-item label="有多囊卵巢综合征病史的女性">
                  <el-select v-model="detail.commonValue" placeholder="请选择">
                    <el-option v-for="item in commonOptions" :key="item.value" :label="item.label" :value="item.value"
                      style="width: 200px">
                    </el-option>
                  </el-select>
                </el-descriptions-item>

                <el-descriptions-item label="长期接受抗精神病药物和(或)抗抑郁药物治疗">
                  <el-select v-model="detail.commonValue" placeholder="请选择">
                    <el-option v-for="item in commonOptions" :key="item.value" :label="item.label" :value="item.value"
                      style="width: 200px">
                    </el-option>
                  </el-select>
                </el-descriptions-item>

                <el-descriptions-item label="伴有与胰岛素抵抗相关的临床状态(如黑棘皮征等)">
                  <el-select v-model="detail.commonValue" placeholder="请选择">
                    <el-option v-for="item in commonOptions" :key="item.value" :label="item.label" :value="item.value"
                      style="width: 200px">
                    </el-option>
                  </el-select>
                </el-descriptions-item>

                <el-descriptions-item label="中国糖尿病风险评分总分≥25分">
                  <el-select v-model="detail.commonValue" placeholder="请选择">
                    <el-option v-for="item in commonOptions" :key="item.value" :label="item.label" :value="item.value"
                      style="width: 200px">
                    </el-option>
                  </el-select>
                </el-descriptions-item>

                <el-descriptions-item label="评估">
                  <el-button type="primary" size="small" @click="submit()" style="width: 210px">提交评估</el-button>
                </el-descriptions-item>

                <el-descriptions-item label="评估结果">
                  <el-input disabled v-model="result2" style="width: 210px"></el-input>
                </el-descriptions-item>

              </el-descriptions>
            </div>

            <el-row style="margin-top: 20px;">
              <el-button type="primary" size="small" @click="submit()"
                style="margin-top: 10px; margin-right: 80px; width: 100px;float: right;">提交评估结果</el-button>
              <el-button type="primary" size="small" @click="setDialogClosed()"
                style="margin-top: 10px; margin-right: 10px; width: 100px;float: right;">关闭</el-button>
            </el-row>
          </el-tab-pane>
        </el-tabs>
      </el-container>
    </el-dialog>
  </div>
</template>

<script>
import { addPatientEasyillDiabetsModel } from "@/api/health/EhrQuery";

export default {
  components: {},
  data() {
    return {
      showDialog: false,
      title: "糖尿病易患人群筛查表",
      activeName: "first",
      pInfo: null,
      pId: null,
      detail: {
        patientId: null,
        patientName: null,
        healthNo: null,
        idcard: null,
        gender: null,
        age: null,
        bmi: null,
        waist: null,
        sbp: null,
        dbp: null,
        diabetFamily: "无家族史",
        height: null,
        weight: null,
        commonValue: null
      },
      familyHistoryOptions: [
        {
          value: "1",
          label: "有家族史",
        },
        {
          value: "2",
          label: "无家族史",
        },
      ],
      sexOptions: [
        {
          value: "1",
          label: "女",
        },
        {
          value: "2",
          label: "男",
        },
      ],
      result: 0,
      result2: null,
      commonOptions: [
        {
          value: "1",
          label: "是",
        },
        {
          value: "2",
          label: "否",
        },
      ]
    };
  },
  methods: {
    // 编辑初始化页面内容
    async init(dataContext) {
      console.log(dataContext);
      this.showDialog = true;

      this.pInfo = dataContext;

      this.detail.patientId = dataContext.patientId;
      this.detail.patientName = dataContext.name;
      this.detail.healthNo = dataContext.healthNo;
      this.detail.idcard = dataContext.idcard;
      this.detail.gender = dataContext.gender;
      this.detail.age = this.getAge(dataContext.birthday);
    },
    // 关闭对话框触发
    setDialogClosed() {
      this.detail.bmi = null;
      this.detail.waist = null;
      this.detail.sbp = null;
      this.detail.dbp = null;
      this.detail.diabetFamily = "无家族史";
      this.detail.height = null;
      this.detail.weight = null;
      this.result = 0;

      this.$emit("update")

      this.showDialog = false;
    },
    submit() {
      if (!this.detail.sbp || !this.detail.dbp) {
        this.$message({
          message: "请输入血压！",
          type: "error"
        })
        return;
      }

      if (!this.detail.height) {
        this.$message({
          message: "请输入身高！",
          type: "error"
        })
        return;
      }

      if (!this.detail.weight) {
        this.$message({
          message: "请输入体重！",
          type: "error"
        })
        return;
      }

      if (!this.detail.waist) {
        this.$message({
          message: "请输入腰围！",
          type: "error"
        })
        return;
      }

      if (!this.detail.diabetFamily) {
        this.$message({
          message: "请选择糖尿病家族史！",
          type: "error"
        })
        return;
      }

      this.detail.bmi = Number(this.detail.weight / Math.pow(this.detail.height / 100, 2)).toFixed(2)

      addPatientEasyillDiabetsModel(this.detail).then((response) => {
        console.log(response);
        if (response.msg == "success") {
          this.$message({
            message: "提交成功！",
            type: "success",
          });
          // this.showDialog = false;
          var data = response.data;
          this.result = data.score;
        }
      });
    },
    // 计算当前年龄
    getAge(birthday) {
      if (birthday == null) return "";

      var birthdays = new Date(birthday.replace(/-/g, "/"));
      let d = new Date();
      let age =
        d.getFullYear() -
        birthdays.getFullYear() -
        (d.getMonth() < birthdays.getMonth() ||
          (d.getMonth() == birthdays.getMonth() &&
            d.getDate() < birthdays.getDate())
          ? 1
          : 0);
      return age;
    }
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .el-dialog {
    margin-top: 5vh !important;
  }

  .el-descriptions-item__label.is-bordered-label {
    width: 140px;
  }

  .el-checkbox-group {
    width: 100px;
  }
}
</style>